import Decimal from 'decimal.js';

interface GetPointsFraction {
  currentTotalAmount: number | string;
  currentFraction: number;
  newTotalAmount: number;
}

const getPointsFraction = ({
  currentTotalAmount,
  currentFraction,
  newTotalAmount,
}: GetPointsFraction) => {
  if (currentTotalAmount == newTotalAmount) return currentFraction;

  /*
    eg.
    currentTotalAmount  =   2000
    currentFraction     =   0.5
    originalCashAmount  === 1000
  */
  const originalCashAmount = Decimal.mul(
    currentTotalAmount,
    1 - currentFraction,
  )
    .toDecimalPlaces(2, Decimal.ROUND_HALF_EVEN)
    .toNumber();

  /*
    eg.
    originalCashAmount  =   1000
    newTotalAmount      =   1500
    newCashFraction     === 0.6666
  */
  const newCashFraction = Decimal.div(originalCashAmount, newTotalAmount);

  /*
    Points fraction is inverse of cash fraction.
    eg.
    newCashFraction =   0.6666
    result          === 0.3333
  */
  return Decimal.sub(1, newCashFraction).toNumber();
};

export default getPointsFraction;
